import { Helmet } from "./components/Helmet";
import Navbar from "@/components/feature/Navbar";
import HeroSection from "./sections/HeroSection";
import FeatureGrid from "./sections/FeatureGrid";
import LatestUpdates from "./sections/LatestUpdates";
import Testimonials from "./sections/Testimonials";
import CTASection from "./sections/CTASection";
import FAQSection from "./sections/FAQSection";
import Footer from "@/components/feature/Footer";

export default function Home() {
  return (
    <>
      <Helmet
        title="韩国漫画无删减漫画下拉式-免费韩漫大全-韩国在线漫画网"
        description="韩国在线漫画网提供无删减韩国漫画下拉式阅读，免费韩漫大全涵盖各类热门题材，更新速度快、资源覆盖面广，为您打造便捷的阅读平台。"
        keywords="韩国漫画,无删减漫画,下拉式漫画,免费韩漫大全,韩国在线漫画网,韩漫更新"
        canonicalUrl="http://uqdww.cn/"
        ogTitle="韩国漫画无删减漫画下拉式-免费韩漫大全-韩国在线漫画网"
        ogDescription="韩国在线漫画网提供无删减韩国漫画下拉式阅读，免费韩漫大全涵盖各类热门题材"
        schemaJsonLd={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "这个网站收费吗？",
              "acceptedAnswer": { "@type": "Answer", "text": "完全免费！韩漫头条致力于为韩漫爱好者提供免费的阅读平台，所有漫画均可免费阅读，无需任何付费。" }
            },
            {
              "@type": "Question",
              "name": "漫画更新频率如何？",
              "acceptedAnswer": { "@type": "Answer", "text": "我们的团队每天更新，保持与原版同步的更新频率。热门连载漫画通常在原版更新后24小时内完成翻译并上线。" }
            },
            {
              "@type": "Question",
              "name": "支持哪些阅读方式？",
              "acceptedAnswer": { "@type": "Answer", "text": "我们采用下拉式阅读模式，无需翻页，一键下滑即可流畅阅读。同时支持PC端和移动端。" }
            },
            {
              "@type": "Question",
              "name": "漫画是高清画质吗？",
              "acceptedAnswer": { "@type": "Answer", "text": "是的，所有漫画均采用高清画质呈现，确保读者能够享受到最清晰细腻的画面细节。" }
            },
            {
              "@type": "Question",
              "name": "找不到想看的漫画怎么办？",
              "acceptedAnswer": { "@type": "Answer", "text": "您可以通过搜索功能查找，或浏览我们的分类页面。如果仍然找不到，欢迎通过联系表单向我们反馈。" }
            },
            {
              "@type": "Question",
              "name": "支持离线下载吗？",
              "acceptedAnswer": { "@type": "Answer", "text": "目前我们仅支持在线阅读。为了提供最佳体验和保证内容更新及时，建议您在网络环境下阅读。离线功能正在规划中。" }
            }
          ]
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeatureGrid />
        <LatestUpdates />
        <Testimonials />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}